import { render, staticRenderFns } from "./ConfigAlertPagerTree.vue?vue&type=template&id=700efc36&scoped=true"
import script from "./ConfigAlertPagerTree.vue?vue&type=script&lang=js"
export * from "./ConfigAlertPagerTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700efc36",
  null
  
)

export default component.exports